export default __webpack_public_path__ + "static/media/bg.b8fc99d5.png";